function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import React, { useState } from 'react';
import { Field } from '@applyboard/ui-components';
import { Flex, Tag, Heading, Text, Box, Button } from '@applyboard/crystal-ui';
import { CheckboxListField } from "../../CheckboxListField";
import { PreferencesContainer } from "../../Layout/PreferencesContainer";
import { Layout } from "../../Layout";
import { useAppContext } from "../../../CEF/Providers";
function getSeptAndJanLabels(data) {
  return data.reduce(function (popularMonths, year) {
    var filteredMonths = year.children.filter(function (month) {
      return month.label.startsWith('September') || month.label.startsWith('January');
    });
    return popularMonths.concat(filteredMonths);
  }, []);
}
export var Content = function Content(_ref) {
  var options = _ref.options,
    skipSubmit = _ref.skipSubmit,
    defaultValues = _ref.defaultValues,
    handleIntakeChange = _ref.handleIntakeChange;
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  userId = userId ? userId.toString() : null;
  var popularIntakes = getSeptAndJanLabels(options);
  var getSelectedTags = function getSelectedTags(defaultValues) {
    var defaultSelectedIntakes = [];
    var _iterator = _createForOfIteratorHelper(defaultValues.intakes),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        var intakeIsPopular = popularIntakes.find(function (intake) {
          return intake.name === key;
        });
        if (intakeIsPopular) {
          defaultSelectedIntakes.push(intakeIsPopular.name);
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return defaultSelectedIntakes;
  };
  var _useState = useState(function () {
      return getSelectedTags(defaultValues);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTags = _useState2[0],
    setSelectedTags = _useState2[1];
  var handleTagClick = function handleTagClick(intake) {
    setSelectedTags(function (prevSelected) {
      return prevSelected.includes(intake) ? prevSelected.filter(function (name) {
        return name !== intake;
      }) : [].concat(_toConsumableArray(prevSelected), [intake]);
    });
  };
  var skipButton = /*#__PURE__*/React.createElement(Button, {
    "aria-label": "",
    emphasis: "highlighted",
    intent: "secondary",
    size: "lg",
    onClick: skipSubmit,
    width: "fill",
    type: "button"
  }, "Skip");
  var preferencesContainerProps = userId ? {
    skipButton: skipButton
  } : {
    skipButton: skipButton,
    submitLabel: 'Explore Programs'
  };
  return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(PreferencesContainer, preferencesContainerProps, /*#__PURE__*/React.createElement(Heading, {
    align: "start",
    contrast: "high",
    intent: "secondary",
    mb: 8,
    level: 1,
    variant: "titleL"
  }, "When do you want to start your studies?"), /*#__PURE__*/React.createElement(Box, {
    pb: 3
  }, /*#__PURE__*/React.createElement(Text, {
    intent: "secondary",
    contrast: "mid",
    variant: "labelM"
  }, "Popular")), /*#__PURE__*/React.createElement(Flex, {
    gap: 2,
    justify: "start",
    wrap: true
  }, popularIntakes.map(function (intake, index) {
    return /*#__PURE__*/React.createElement(Tag, {
      key: index,
      intent: selectedTags.includes(intake.name) ? 'primary' : 'secondary',
      onClick: function onClick() {
        return handleTagClick(intake.name);
      },
      overflow: "normal",
      size: "sm",
      as: "button"
    }, intake.label);
  })), /*#__PURE__*/React.createElement(Field, {
    as: CheckboxListField,
    name: "intakes",
    label: "",
    options: options,
    selectedTags: selectedTags,
    setSelectedTags: setSelectedTags,
    popularIntakes: popularIntakes,
    required: "Please select at least one option.",
    onChange: function onChange(intakes) {
      return handleIntakeChange(intakes);
    }
  })));
};